import api from "./index";
import ENDPOINTS from "./endpoints";

export const getModelPreferences = async (orgId, userId) => {
  const response = await api({
    method: "GET",
    url: ENDPOINTS.GET_MODEL_PREFERENCES,
    params: { org_id: orgId, user_id: userId },
  });
  return response.data;
};

export const toggleModelEnabled = async (orgId, userId, modelId, enabled) => {
  const response = await api({
    method: "PATCH",
    url: `${ENDPOINTS.TOGGLE_MODEL}/${modelId}/toggle`,
    data: {
      org_id: orgId,
      user_id: userId,
      enabled: enabled,
    },
  });
  return response.data;
};

export const setDefaultModel = async (orgId, userId, modelId) => {
  const response = await api({
    method: "POST",
    url: `${ENDPOINTS.SET_DEFAULT_MODEL}/${modelId}/default`,
    data: {
      org_id: orgId,
      user_id: userId,
    },
  });
  return response.data;
};

export const getAppearancePreferences = async (orgId, userId) => {
  const response = await api({
    method: "GET",
    url: ENDPOINTS.GET_APPEARANCE_PREFERENCES,
    params: { org_id: orgId, user_id: userId },
  });
  return response.data;
};

export const updateAppearancePreferences = async (orgId, userId, theme, colorScheme) => {
  const response = await api({
    method: "PATCH",
    url: ENDPOINTS.UPDATE_APPEARANCE_PREFERENCES,
    data: {
      org_id: orgId,
      user_id: userId,
      ...(theme !== undefined && { theme }),
      ...(colorScheme !== undefined && { color_scheme: colorScheme }),
    },
  });
  return response.data;
};

export const getProfilePreferences = async () => {
  const response = await api({ method: "GET", url: ENDPOINTS.PROFILE_PREFERENCES });
  return response.data.data;
};

export const updateLocalizationPreferences = async (locale) => {
  const response = await api({
    method: "PATCH",
    url: ENDPOINTS.LOCALIZATION_PREFERENCES,
    data: { locale },
  });
  return response.data.data;
};

export const createStyle = async (style) => {
  const response = await api({ method: "POST", url: ENDPOINTS.STYLES, data: style });
  return response.data.data;
};

export const updateStyle = async (styleId, style) => {
  const response = await api({
    method: "PATCH",
    url: ENDPOINTS.STYLE(styleId),
    data: style,
  });
  return response.data.data;
};

export const deleteStyle = async (styleId) => {
  const response = await api({ method: "DELETE", url: ENDPOINTS.STYLE(styleId) });
  return response.data.data;
};

export const setActiveStyle = async (styleId) => {
  const response = await api({
    method: "PUT",
    url: ENDPOINTS.ACTIVE_STYLE,
    data: { style_id: styleId },
  });
  return response.data.data;
};

